export interface GetAuthorityListRequest {
  authorityType: string
  authorityNo: string
}

export function GetAuthorityListRequestToJSON(
  value: GetAuthorityListRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined
  }
}
